<template>
  <v-app>
    <v-main v-if="event">
      <v-row class="justify-center">
        <v-col cols="4">
          <v-img contain height="65px" :src="event.logo" />
          <br />
          <v-divider></v-divider>

          <v-card>
            <v-card-title class="justify-center">{{
              this.$store.state.events.event.name
            }}</v-card-title>
            <v-card-subtitle style="text-align:center; word-break: break-word;">
              Request your voting ballot by email
            </v-card-subtitle>
            <v-card-text>
              <v-form>
                <v-text-field
                  :error-messages="errorMessage"
                  :disabled="loading"
                  ref="email"
                  v-model="email"
                  :rules="emailRules"
                  label="Email Address"
                  prepend-inner-icon="mdi-email"
                  placeholder="someone@email.com"
                  required
                  outlined
                >
                </v-text-field>
                <v-autocomplete
                  v-if="changeTz"
                  :disabled="loading"
                  item-text="label"
                  item-value="tzCode"
                  v-model="selectedTz"
                  :items="timezoneList"
                  prepend-inner-icon="mdi-web"
                  label="Select your timezone"
                  outlined
                ></v-autocomplete>
                <div v-if="!changeTz && !loading">
                  Timezone: {{ selectedTz }} -
                  <span
                    ><router-link to=""
                      ><span @click="changeTz = true">change</span></router-link
                    ></span
                  >
                </div>
                <v-card-actions class="justify-center"
                  ><v-btn
                    @click="submit"
                    block
                    large
                    :disabled="loading"
                    color="primary"
                    >Submit</v-btn
                  >
                </v-card-actions>
                <div class="align-center" v-if="loading">email sent!</div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>
<script>
import api from "@/services/api";
//import moment from 'moment'
import moment from "moment-timezone";
import timezoneList from "@/services/timezones";
import { mapState } from "vuex";
export default {
  data() {
    return {
      changeTz: false,
      timezoneList,
      selectedTz: moment.tz.guess(),
      errorMessage: "",
      valid: false,
      email: "",
      loading: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  computed: {
    ...mapState({ event: (state) => state.events.event })
  },
  async created() {
    //console.log(this.selectedTz)
    await this.$store.dispatch("loadEvent", this.$route.params.eventId);
    //this.$VuetifySwitchTheme(this.$store.state.events.event.theme);
  },
  methods: {
    async submit() {
      //const timezone = moment.tz.guess()
      //console.log(this.selectedTz);
      if (this.$refs.email.validate()) {
        try {
          await api.sendTokenEmail({
            eventId: this.event._id,
            email: this.email,
            timezone: this.selectedTz
          });
          this.loading = true;
        } catch (err) {
          //console.error('error', err);
          this.errorMessage = err.error;
        }
      }
    }
  }
};
</script>
